module.exports = __webpack_public_path__ + "img/v1-12.11450dcb.png";